import React from "react";

import ReactHelmet from "../../components/react-helmet/react-helmet";
const Massachusettsheader = () => {
  return (
    <>
      <ReactHelmet
        title={"Facilities For Sober Living in Massachusetts | Taste Recovery"}
        description={
          "Browse available facilities for sober living in Massachusetts offering safe, peer-reviewed & supportive environments to help individuals maintain lasting recovery."
        }
      />
    </>
  );
};

export default Massachusettsheader;
